import React from 'react';

const mapFieldToInput = (Component) => ({
  input, meta, label, ...props
}) => {
  const fieldProps = {
    disabled: props.disabled || meta.submitting,
    options: props.options,
    loading: props.loading,
    isClearable: props.isClearable || false,
    onOptionChange: props.onOptionChange || null,
    initialValue: props.initialValue,
    ...props,
  };

  if (label) {
    fieldProps.label = label;
  }

  return (
    <Component
      {...input}
      {...fieldProps}
      error={meta.touched && typeof meta.error !== 'undefined'}
      helperText={meta.touched && meta.error ? meta.error : null}
    />
  );
};

export default mapFieldToInput;
